import { ofType } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/internal-compatibility';
import * as api from '@api/profile';
import { of } from 'rxjs';
import {
  SET_PROFILE_SETTINGS,
  SET_PROFILE_SETTINGS_ERROR,
  SET_PROFILE_SETTINGS_SUCCESS,
} from '@actions/profile';

export const setProfileSettings = action$ =>
  action$.pipe(
    ofType(SET_PROFILE_SETTINGS),
    switchMap(action =>
      fromPromise(api.setProfileSettings(action.payload)).pipe(
        map(response => {
          return { type: SET_PROFILE_SETTINGS_SUCCESS, payload: response };
        }),
        catchError(err =>
          of({ type: SET_PROFILE_SETTINGS_ERROR, payload: err }),
        ),
      ),
    ),
  );
